import React, { Component } from 'react'
import RichText from '../Form/RichText'
import { withSettings } from '../withSettings'

@withSettings
export default class RecommendedSearchTemplate extends Component {
  componentDidMount() {
    this.props.registerDataHandler(data => this.props.setSettingsAt('email.recommended_search_template', data))
  }

  render() {
    const { subject, body } = this.props.getSettingsAt('email.recommended_search_template')
    const dynamicFields = this.props.getDynamicFieldsFor('new_lead')

    return (
      <div>
        <div className="form-section">
          <p className="muted">
            Customize the email sent to leads when some recommended search results are made.
          </p>

          <p>
            <strong>Recommendation: While you can edit this template, we suggest using some variation of the default text.</strong>
          </p>

          <label>Subject</label>
          <RichText singleline name="subject" defaultValue={subject} dynamicFields={dynamicFields} />
        </div>

        <div className="form-section">
          <label>Message</label>
          <RichText name="body" defaultValue={body} dynamicFields={dynamicFields} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Email/RecommendedSearchTemplate.js